export const getUserStatusKey = (isUserLogged, widget) => (isUserLogged ? widget.loggedKey : widget.notLoggedKey);
